package gr.tech.pdfgenerator.styles

import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import gr.tech.pdfgenerator.util.CONSTANTS.FONT_FAMILY
import gr.tech.pdfgenerator.util.CONSTANTS.FONT_FAMILY2
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

val T3InputTitleStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .textAlign(TextAlign.Start)
            .fontSize(1.25.cssRem)
            .fontFamily(FONT_FAMILY)
            .fontWeight(FontWeight.Bold)
            .margin(topBottom = 1.cssRem)
    }
}

val T3DeliverableTableStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .margin(bottom = 16.px)
            .fontFamily(FONT_FAMILY2)
            .borderCollapse(BorderCollapse.Collapse)
    }
}

val T3DeliverableColumnPreview = CssStyle {
    base {
        Modifier
            .border(1.px, LineStyle.Solid, Colors.Black)
    }
}

val T3DeliverableRowPreview = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .backgroundColor(Colors.Transparent)
            .transition(Transition.all(100.ms))
    }
}

val T3DeliverableTextPreview = CssStyle {
    base {
        Modifier
            .overflowWrap(OverflowWrap.BreakWord)
            .fontSize(0.875.cssRem)
            .color(Colors.Black)
    }
}

val T3TableControlCellStyle = CssStyle {
    base {
        Modifier
            .width(25.px)
            .padding(leftRight = 6.px, topBottom = 0.px)
            .whiteSpace(WhiteSpace.NoWrap)
            .verticalAlign(VerticalAlign.Middle)
            .textAlign(TextAlign.Center)
    }
}

val T3TableGripStyle = CssStyle {
    base {
        Modifier
            .cursor(Cursor.Grab)
            .color(Colors.Gray)
            .margin(right = 4.px)
    }
    hover {
        Modifier.color(Colors.Black)
    }
}

val T3TableDeleteButtonStyle = CssStyle {
    base {
        Modifier
            .padding(leftRight = 4.px, topBottom = 2.px)
            .backgroundColor(Colors.Transparent)
            .color(Theme.SpectrumRed.rgb)
            .cursor(Cursor.Pointer)
    }
    hover {
        Modifier
            .transition(Transition.all(100.ms))
            .opacity(75.percent)
    }
}

val T3AddRowButtonStyle = CssStyle {
    base {
        Modifier
            .margin(top = 8.px)
            .padding(leftRight = 12.px, topBottom = 6.px)
            .backgroundColor(Theme.MediumGreen.rgb)
            .noBorder()
            .borderRadius(4.px)
            .color(Colors.White)
            .fontSize(0.875.cssRem)
            .cursor(Cursor.Pointer)
    }
    hover {
        Modifier
            .transition(Transition.all(100.ms))
            .backgroundColor(Theme.DarkGreen.rgb)
    }
}
